import React from 'react';
import type { RequestOptions } from 'searchkit';

import {
  SearchResults,
  SearchkitWrapper,
} from '@uncinc/react-searchkit';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';

import { APP_OPTIONS, SEARCHKIT_HOST_URL } from '../../../config/constants';

import './style.scss';

type PartnerHit = {
  page_title: [string];
  image_ratio_original_xs: [string];
  link_url: [string];
  link_text: [string];
};

const Sponsors: React.FC = () => {
  const requestOptions: RequestOptions = {
    getBaseFilters: () => [
      {
        bool: {
          must: [
            {
              term: {
                content_type: {
                  value: 'partner',
                },
              },
            },
            {
              term: {
                labels_searchable: {
                  value: 'sponsor',
                },
              },
            },
            {
              exists: {
                field: 'image_ratio_original_xs',
              },
            },
            {
              exists: {
                field: 'link_url',
              },
            },
          ],
        },
      },
    ],
  };

  return (
    <div className="Sponsors">
      <SearchkitWrapper
        connection={{
          host: SEARCHKIT_HOST_URL,
        }}
        indexName={APP_OPTIONS?.parameters.searchkitIndexAllContent}
        routing={false}
        searchSettings={{
          search_attributes: [],
          result_attributes: [
            'page_title',
            'image_ratio_original_xs',
            'link_url',
            'link_text',
          ],
          sorting: {
            default: {
              field: 'created',
              order: 'desc',
            },
          },
        }}
        requestOptions={requestOptions}
      >
        <SearchResults
          className="Sponsors__sponsors"
          renderItem={
            (hit: PartnerHit) => (
              <div className="Sponsors__sponsors__logo">
                <CoreLink href={hit.link_url[0]} title={hit.link_text[0]}>
                  <Image lazyload={false} alt={hit.page_title[0]} src={hit.image_ratio_original_xs} />
                </CoreLink>
              </div>
            )
          }
          emptyState={<div />}
        />
      </SearchkitWrapper>
    </div>
  );
};

export default Sponsors;
